'use client';

/**
 * Register Form Wrapper with Redirect Support
 * 
 * Client component that reads the redirect query parameter and passes it to RegisterForm.
 */

import { useSearchParams, usePathname } from 'next/navigation';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { useTenantOptional } from '@/contexts/TenantContext';

export function RegisterFormWithRedirect() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const redirect = searchParams.get('redirect');
  const tenant = useTenantOptional();
  
  // Extract locale from current pathname (e.g., /en/register -> en)
  const localeMatch = pathname.match(/^\/([a-z]{2})(\/|$)/);
  const locale = localeMatch ? localeMatch[1] : (tenant?.locale || 'en');
  
  // Use the redirect param if provided, otherwise default to /{locale}/account
  // Ensure the redirect path includes the locale prefix for proper routing
  const redirectTo = redirect || `/${locale}/account`;
  
  return (
    <RegisterForm
      redirectTo={redirectTo}
      showLoginLink={true}
      loginUrl={redirect ? `/${locale}/login?redirect=${encodeURIComponent(redirect)}` : `/${locale}/login`}
      showSocialAuth={true}
      minPasswordLength={8}
    />
  );
}
